module.exports = __webpack_public_path__ + "static/img/adult-store-icon.9698448e.svg";